<template>
    <div class="map-panel" :class="{visible}">
        <slot/>
    </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        // No logic needed — props are used directly in template
    },
});
</script>
